const mainNavigationItems = document.querySelectorAll(".header__bottom-navigation > ul > li");

const closeSubMenus = () => {
  mainNavigationItems.forEach(li => {
    li.classList.remove("is-active");
  })
}

export {closeSubMenus}